export const APP_SUPPORT_REPORT_KIND_OPTIONS = [
  { value: 'anregungen', label: 'Anregungen' },
  { value: 'fehler', label: 'Fehler' },
  { value: 'frage', label: 'Frage' },
];

export const APP_SUPPORT_AREA_OPTIONS = [
  { value: 'logbuch', label: 'Logbuch' },
  { value: 'einsatz', label: 'Einsatz' },
  { value: 'uebungsplanung', label: 'Übungsplanung' },
  { value: 'rueckmeldungen', label: 'Rückmeldungen' },
  { value: 'grundlehrgang_srht', label: 'Grundlehrgang SRHT' },
  { value: 'administration', label: 'Administration' },
  { value: 'kein_bestimmter', label: 'Kein bestimmter Teilbereich' },
];

export const APP_SUPPORT_STATUS_OPTIONS = [
  { value: 'open', label: 'Offen', color: 'warning' },
  { value: 'resolved', label: 'Erledigt', color: 'success' },
];

export const defaultAppSupportForm = {
  reportKind: 'frage',
  appArea: 'logbuch',
  description: '',
  linksText: '',
};

function parseLinksText(value) {
  return String(value || '')
    .split(/\r?\n/)
    .map((item) => item.trim())
    .filter(Boolean);
}

export function getInitialAppSupportFormState() {
  return { ...defaultAppSupportForm };
}

export function formatAppSupportReportKind(value) {
  return APP_SUPPORT_REPORT_KIND_OPTIONS.find((item) => item.value === value)?.label || '-';
}

export function formatAppSupportArea(value) {
  return APP_SUPPORT_AREA_OPTIONS.find((item) => item.value === value)?.label || '-';
}

export function buildAppSupportTitlePreview(formState) {
  return `${formatAppSupportReportKind(formState?.reportKind)} - ${formatAppSupportArea(formState?.appArea)}`;
}

export function normalizeAppSupportStatus(value) {
  return String(value || '').trim() === 'resolved' ? 'resolved' : 'open';
}

export function formatAppSupportStatusLabel(value) {
  const normalizedStatus = normalizeAppSupportStatus(value);
  return APP_SUPPORT_STATUS_OPTIONS.find((item) => item.value === normalizedStatus)?.label || '-';
}

export function formatAppSupportStatusColor(value) {
  const normalizedStatus = normalizeAppSupportStatus(value);
  return APP_SUPPORT_STATUS_OPTIONS.find((item) => item.value === normalizedStatus)?.color || 'default';
}

export function getAppSupportStatusStats(entries) {
  return entries.reduce((stats, entry) => {
    const normalizedStatus = normalizeAppSupportStatus(entry?.status);
    stats[normalizedStatus] += 1;
    return stats;
  }, { open: 0, resolved: 0 });
}

export function matchesAppSupportStatusFilter(entry, statusFilter) {
  return statusFilter === 'all' || normalizeAppSupportStatus(entry?.status) === statusFilter;
}

export function buildAppSupportSubmitPayload(formState) {
  return {
    topicKey: 'app_support',
    description: String(formState?.description || '').trim(),
    payload: {
      reportKind: String(formState?.reportKind || '').trim(),
      appArea: String(formState?.appArea || '').trim(),
      links: parseLinksText(formState?.linksText),
    },
  };
}

export function buildAppSupportEditFormState(entry) {
  const payload = entry?.payload || {};

  return {
    reportKind: payload.reportKind || 'frage',
    appArea: payload.appArea || 'logbuch',
    description: entry?.description || '',
    linksText: Array.isArray(payload.links) ? payload.links.join('\n') : '',
  };
}